import type { ModalData } from '@presentation/components/Modal';
import type { MouseEventHandler } from 'react';

export interface ApplicationExistsModalData {
  modal: ModalData;
  onContinueClick?: MouseEventHandler;
  onCancelClick?: MouseEventHandler;
}

export interface ApplicationExistsModalProps extends ApplicationExistsModalData {}
